import { SmsSender, MessageType, EmailSender } from 'modules/templateIndex';
import { BaseOption } from 'ui/selects';
import { CampaignTemplateOption } from './CampaignTemplateOption';
import { SendersType, SenderValueType } from './types';

const getOption = (id: string, name: string, value: SenderValueType) => ({
  id,
  label: <CampaignTemplateOption text={name} />,
  value,
  ...(typeof value === 'string' && { doubleLine: value }),
});

export const parseSmsSenders = (smsSenders: SendersType = []): BaseOption<SenderValueType>[] =>
  (smsSenders as SmsSender[]).map(({ name, id }) => getOption(`sms-sender-${id}`, name, id));

export const parseEmailSenders = (emailSenders: SendersType = []): BaseOption<SenderValueType>[] =>
  (emailSenders as EmailSender[]).map(({ email, senderName }) =>
    getOption(`email-sender-${email}`, senderName, email),
  );

export const parseMessageTypes = (
  messageTypes: MessageType[] = [],
): BaseOption<SenderValueType>[] =>
  messageTypes.map(({ id, name }) => getOption(`message-type-${id}`, name, id));

export const getDefaultMessageTypeAndSender = ({
  isMediumEmail,
  isMediumSMS,
  senders,
  messageTypes,
  templateAndContent,
}: {
  isMediumEmail: boolean;
  isMediumSMS: boolean;
  senders: SendersType;
  messageTypes: MessageType[];
  templateAndContent: any;
}) => {
  const messageType = messageTypes.find(
    (msg) => msg.name === templateAndContent?.messageType?.name,
  )?.id;
  if (isMediumEmail) {
    const senderEmail = (senders as EmailSender[]).find(
      (sender: EmailSender) => sender.email === templateAndContent?.primaryContent?.fromEmail,
    );
    return {
      messageType,
      sender: senderEmail?.email,
    };
  }
  if (isMediumSMS) {
    const senderSms = (senders as SmsSender[]).find(
      (sender: SmsSender) => sender.name === templateAndContent?.primaryContent?.smsSender?.name,
    );
    return {
      messageType,
      sender: senderSms?.id,
    };
  }
  return { messageType };
};
